import React, { useEffect, useRef, useState } from 'react';

function ScannerInput() {
    const [scanValue, setScanValue] = useState('');
    const barcodeRef = useRef({ code: "", time: new Date().getTime() })

    useEffect(() => {
        function handleKeyDown(event: any) {
            let curTime = new Date().getTime()

            if (event.key === 'Enter') {
                // console.log(event)

                // Scanner input received, extract the value
                // const scannedValue = event.target.value;

                console.log("User Time In: " + barcodeRef.current.code)
                // Call the onScan callback with the scanned value
                // onScan(scannedValue);
                barcodeRef.current.code = ""
                // Clear the input field
                event.target.value = '';
            } else {
                if (curTime - barcodeRef.current.time < 100) {
                    barcodeRef.current.code = barcodeRef.current.code + event.key
                    setScanValue(barcodeRef.current.code);
                }

                else
                    barcodeRef.current.code = event.key
                barcodeRef.current.time = curTime
            }
        }

        // Attach the event listener to the document
        document.addEventListener('keydown', handleKeyDown);

        // Cleanup: Remove the event listener when the component is unmounted
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    // useEffect(() => {
    //     if (scanValue) {
    //         // setScanValue('');
    //         console.log("scanValue: " + scanValue)
    //     }
    // }, [scanValue, setScanValue]);

    // return (
    //     <div>
    //         {/* <input type="text" placeholder="Scan input..." autoComplete="off" /> */}
    //         {/* <input
    //             type="text"
    //             placeholder="Scan input..."
    //             autoComplete="off"
    //             value={scanValue}
    //             onChange={(event) => setScanValue(event.target.value)}
    //         /> */}
    //         <p>{scanValue}</p>
    //     </div>

    // );
    return { scanValue };
}

export default ScannerInput;
